import React, { Component } from "react";

class FieldRadio extends Component {
    render() {
        let { fieldConfig, schema } = this.props;

        return (
            <div className="form-radio">
                {schema.enum.map((enumVal, i) => {
                    return (
                        <div
                            className="form-check"
                            key={`${fieldConfig.name}_${i}`}
                        >
                            <input
                                checked={fieldConfig.value === enumVal}
                                className="form-check-input"
                                id={`${fieldConfig.name}_${i}`}
                                name={fieldConfig.name}
                                onBlur={fieldConfig.onBlur}
                                onChange={fieldConfig.onChange}
                                onSubmit={fieldConfig.onSubmit}
                                type="radio"
                                value={enumVal}
                            />
                            <label
                                className="form-check-label"
                                htmlFor={`${fieldConfig.name}_${i}`}
                            >
                                {"enumNames" in schema
                                    ? schema.enumNames[i]
                                    : enumVal}
                            </label>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default FieldRadio;



// WEBPACK FOOTER //
// ./src/FieldRadio.js